import React, { useImperativeHandle, useState } from "react";
import { Button } from "./Elements";
import Modal from "./Modal";


const ConfirmationModal = React.forwardRef(({ }, ref) => {

    const [isVisible, setIsVisible] = useState(false);
    const [modalValues, setModalValues] = useState({
        title: "",
        contentText: "",
        confirmText: "",
        cancelText: "",
        confirmCallBack: null,
        modalIcon: ""
    });
    useImperativeHandle(ref, () => ({

        showConfirm({ title, contentText, confirmText, cancelText, modalIcon, confirmCallBack }) {

            setModalValues({ title, contentText, confirmText, cancelText, confirmCallBack, modalIcon });
            setIsVisible(true);
        },
        hideModal() {
            setIsVisible(false);
        }

    }));



    return (
        <Modal openModal={isVisible} setOpenModal={setIsVisible}>
            <div>
                <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <h3 className="text-md leading-6 font-medium text-gray-900">
                            {modalValues.title}
                        </h3>
                        <div className="flex justify-center">
                            <div className="mt-4 flex flex-row items-center">
                                <img
                                    className="text-error h-10 w-10"
                                    src={modalValues.modalIcon ? modalValues.modalIcon : "/icons/warning.svg"}
                                    alt="error"

                                />
                                <p className="pl-1 text-sm text-gray-500">
                                    {modalValues.contentText}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5 sm:mt-4 flex justify-end space-x-2">
                    <Button
                        color="gray"
                        hover="gray"
                        size="xs"
                        callback={() => setIsVisible(false)}
                    >
                        {modalValues.cancelText || "İptal"}
                    </Button>
                    <Button
                        color="primary"
                        hover="primary"
                        size="xs"
                        callback={() => {
                            modalValues.confirmCallBack()
                            setIsVisible(false)
                        }}
                    >
                        {modalValues.confirmText || "Onayla"}
                    </Button>
                </div>
            </div>
        </Modal>
    );
})
export default ConfirmationModal;